var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmokeRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 170,
    viewBox: "0 0 438 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.059 50.7104C366.046 53.884 388.355 58.6445 398.011 60.628C402.672 73.6862 410.996 105.456 407.001 128.068C402.006 156.333 386.523 128.068 366.545 121.125C346.567 114.183 317.1 121.125 296.123 121.125H237.687C212.215 121.125 179.252 128.068 139.296 133.027C99.3398 137.985 83.8568 134.514 55.8877 128.068C27.9185 121.621 33.9119 113.191 29.4168 99.8026C25.8208 89.0915 49.8943 88.3973 62.3805 89.3891C71.2041 88.5626 89.0511 85.7196 89.8503 80.9591C90.8492 75.0085 69.3728 66.5785 46.8976 50.7104C28.9174 38.0159 36.0761 37.8175 41.903 39.3051L62.3805 29.3875C77.5305 30.2139 109.029 33.3545 113.824 39.3051C119.817 46.7433 129.307 60.628 139.296 60.628C149.285 60.628 172.259 66.5785 192.237 66.5785H212.215C203.891 61.2892 186.743 50.7104 184.746 50.7104C182.248 50.7104 197.232 42.7763 212.215 39.3051C227.199 35.8339 236.189 45.7515 242.682 50.7104C249.175 55.6693 263.159 76.9921 285.635 75.5044C303.615 74.3143 300.119 65.0909 296.123 60.628C310.441 55.9998 342.072 47.5368 354.059 50.7104Z",
    fill: "url(#paint0_linear_1_987)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_987",
    x: 0.0546875,
    y: 0.387451,
    width: 437,
    height: 169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5,
    result: "effect1_foregroundBlur_1_987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_987",
    x1: 218.555,
    y1: 29.3875,
    x2: 218.555,
    y2: 140.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F3FE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeRight);
export default __webpack_public_path__ + "static/media/smoke-right.bad39df5791a30a505ecef8218546013.svg";
export { ForwardRef as ReactComponent };